export const WORK_COURSER_CUSTOMER_EXPORT_ID = "Trabajo en curso - Clientes";
export const WORK_COURSER_CUSTOMER_TITLE = "Trabajo en curso - Clientes";

export const WORK_COURSER_CUSTOMER_PROPERTIES = {
  soldToCode: "Código de pagador",
  soldToName: "Nombre de pagador",
  shipToCode: "Código de receptor",
  shipToName: "Nombre de receptor",
  serial: "# de documento",
  className: "Clase de documento",
  materialCode: "Código de material",
  materialName: "Nombre de material",
  soldQuantity: "Cantidad Venta (UMV)",
  soldUnit: "UM Venta",
  baseQuantity: "Cantidad Base (UMB)",
  baseUnit: "UM Base",
  parallelQuantity: "Cantidad Paralela (UMP)",
  parallelUnit: "UM Paralela",
  finalPrice: "Precio final",
  discounts: "Descuentos",
  surcharges: "Recargos",
  subtotal: "Subtotal",
  taxes: "Impuestos",
  total: "Total",
};
